import React, { CSSProperties } from 'react';

import styled from 'styled-components';

import * as S from './styled';

const TitleWrapper = styled.div.attrs((props: any) => ({
  textAling: props.textAling
}))`
  text-align: ${(props) => (props.textAling ? 'center' : 'left')};
  @media (min-width: 768px) {
    text-align: left;
  }
`;

interface IProps {
  color?: string;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  style?: CSSProperties;
  title: string;
  textAling?: boolean;
}

const ReusableTitle = ({
  color,
  fontSize,
  fontWeight,
  lineHeight,
  style,
  title,
  textAling
}: IProps) => (
  <S.Wrapper style={{ ...style, lineHeight }} data-testid="cmp-ReusableTitle">
    <TitleWrapper textAling={textAling}>
      <span style={{ color, fontSize, fontWeight }}>{title}</span>
    </TitleWrapper>
  </S.Wrapper>
);

ReusableTitle.defaultProps = {
  textAling: false
};

export default ReusableTitle;
